import { useGLTF } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import React, { useRef, useState } from "react";
import { PointLight } from "three";
import { useFrame } from "@react-three/fiber";
import { stageObject } from "../../interface";
import { HoverText } from "../../HoverText";

export const Trainee = ({
  url,
  scale,
  position,
  getCharacters,
}: stageObject) => {
  const { scene } = useGLTF(url, "/draco/");

  const traineeRef = useRef<any>();
  const textRef = useRef<any>();
  const pointLightRef = useRef<PointLight>(null!);
  const [hovered, setHovered] = useState(false);

  const speed = 0.001; // 初始旋转速度
  const rotation = 0.005;
  const mobileScale = isMobile ? 0.5 : 1;

  // 鼠标移入时显示光源和文本
  const handlePointerOver = () => {
    setHovered(true);
    if (pointLightRef.current) {
      pointLightRef.current.visible = true;
    }
    if (textRef.current) {
      textRef.current.visible = true;
    }
  };

  // 鼠标移出时隐藏光源和文本
  const handlePointerOut = () => {
    setHovered(false);
    if (pointLightRef.current) {
      pointLightRef.current.visible = false;
    }
    if (textRef.current && !isMobile) {
      textRef.current.visible = false;
    }
  };

  let directionX = true;
  let directionY = true;
  let rotationY = true;

  useFrame(() => {
    if (traineeRef.current) {
      //rocketRef.current.rotation.x += 0.01;
      //rocketRef.current.rotation.z += 0.01;
      if (
        traineeRef.current.position.x < 1 * mobileScale ||
        traineeRef.current.position.x > 4 * mobileScale
      ) {
        directionX = !directionX;
        rotationY = Math.random() < 0.5;
      }

      if (
        traineeRef.current.position.y < -3 * mobileScale ||
        traineeRef.current.position.y > 0 * mobileScale
      ) {
        directionY = !directionY;
        rotationY = Math.random() < 0.5;
      }

      if (!hovered) {
        if (directionX) {
          traineeRef.current.position.x -= speed;
        } else {
          traineeRef.current.position.x += speed;
        }

        if (directionY) {
          traineeRef.current.position.y -= speed;
        } else {
          traineeRef.current.position.y += speed;
        }

        if (rotationY) {
          traineeRef.current.rotation.y += rotation;
        } else {
          traineeRef.current.rotation.y -= rotation;
        }
      }

      const { x, y, z } = traineeRef.current.position;
      if (pointLightRef.current) {
        pointLightRef.current.position.set(x, y + 0.2, z + 0.5);
      }

      if (textRef.current) {
        if (isMobile) {
          textRef.current.visible = true;
          textRef.current.fontSize = "0.2";
          textRef.current.position.set(x, y - 0.35, z);
        } else {
          textRef.current.position.set(x + 0.7, y, z);
        }
      }
    }
  });

  return (
    <>
      <primitive
        ref={traineeRef}
        object={scene}
        position={position?.toArray()}
        scale={scale}
        onClick={() => getCharacters("trainee")}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />
      <pointLight
        visible={isMobile}
        ref={pointLightRef}
        intensity={1}
        color={"#ffcc00"}
      />
      <HoverText text={"Nova"} color={"white"} textRef={textRef} />
    </>
  );
};
